import { render, staticRenderFns } from "./ServiceMenu.vue?vue&type=template&id=44b177d0&scoped=true"
import script from "./ServiceMenu.vue?vue&type=script&lang=js"
export * from "./ServiceMenu.vue?vue&type=script&lang=js"
import style0 from "./ServiceMenu.vue?vue&type=style&index=0&id=44b177d0&prod&lang=stylus&scoped=true"
import style1 from "./ServiceMenu.vue?vue&type=style&index=1&id=44b177d0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b177d0",
  null
  
)

export default component.exports